import { Injectable } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';

export interface SequenceFilters {
  date: string | Date | null;
  groupId: string | number | null;
  subjectId: string | number | null;
}

@Injectable({
  providedIn: 'root',
})
export class SequenceStateService {
  private filtersSource = new BehaviorSubject<SequenceFilters>({ date: null, groupId: null, subjectId: null });

  public filters$ = this.filtersSource.asObservable().pipe(filter((f) => !!f.date && !!f.groupId && !!f.subjectId));

  public updateFilters(date: string | Date | null, groupId: number | null, subjectId: number | null) {
    this.filtersSource.next({ date, groupId, subjectId });
  }
}
